import React, { useEffect, useState } from "react";
import moment from 'moment-timezone';
import AddTicket from "./AddTicket";
import SingleTicket from "./SingleTicket";
import NonLoggedUserForm from "./NonLoggedUserForm";
import { __ } from '@wordpress/i18n';

const Tickets = () => {
  // console.log(window.shortcodes_data.current_user);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newTicketClick, setNewTicketClick] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const defaultAvatar = `${hive_front.site_url}/wp-content/plugins/HiveSupportPro/assets/img/agents/user_default.png`;

  const currentUserId = Number(window.shortcodes_data.current_user.ID);
  if (!currentUserId) {
    return (
      <>
        <NonLoggedUserForm />
      </>
    );
  }
  const handleSelectId = (id) => {
    setSelectedId(id);

    const formdata = new FormData();
      formdata.append( "action", 'hive_support_set_customer_seen_status' );
      formdata.append("ticket_id", id );

      const request = fetch(window.hive_support_client_script_object.ajaxurl, {
          method: "POST",
          body: formdata,
      });

  };

  const getTicketByInbox = async () => {
    const formdata = new FormData();
    formdata.append("action", "get_tickets_by_mailbox");
    formdata.append("mailbox", Number(window.shortcodes_data.mailbox_id));
    formdata.append("customerid", currentUserId);
    const response = await fetch(
      window.hive_support_client_script_object.ajaxurl,
      {
        method: "POST",
        body: formdata,
      }
    );
    const result = await response.json();
    
    if (result.success) {
      setTickets(result.data);
      setLoading(false);
    }
  };
  useEffect(() => {
    getTicketByInbox();

    return () => {
      setNewTicketClick(false);
    };
  }, []);

  if (selectedId) {
    return <SingleTicket id={selectedId} />;
  }
  if (newTicketClick) {
    return <AddTicket />;
  }
  if (loading) {
    return (
      <div
        className="w-full h-screen flex justify-center items-center"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div class="hive_support_loader"></div>
      </div>
    );
  }
  return (
    <div
      id="hive_support_client_tickets"
      style={{
        borderColor: "var(--qs-dm-border)",
        color: "var(--qs-dm-text)",
        boxShadow: "none",
        display: "block",
      }}
    >
      <div
        className="hive_support_client_tickets_header"
        style={{
          borderColor: "var(--qs-dm-border)",
          color: "var(--qs-dm-text)",
          boxShadow: "none",
        }}
      >
        <h4
          style={{
            borderColor: "var(--qs-dm-border)",
            color: "var(--qs-dm-title)",
            boxShadow: "none",
          }}
        >
          {__( "Support Portal", "hive-support" )}
        </h4>
        <button
          className="show_form"
          onClick={() => setNewTicketClick(true)}
          style={{
            borderColor: "var(--qs-dm-border)",
            color: "white",
            boxShadow: "none",
            cursor: "pointer",
          }}
        >
          {__( "New Ticket", "hive-support" )}
        </button>
      </div>

      {Array.isArray(tickets) && tickets.length > 0 ? (
        <div
          className="hive_support_client_tickets_items"
          style={{
            borderColor: "var(--qs-dm-border)",
            color: "var(--qs-dm-text)",
            boxShadow: "none",
          }}
        >
          {tickets.map((ticket, index) => (
            <div className="hive_support_client_tickets_item" key={index}>
              <div className="hive_support_client_tickets_item_body">
                
                <img src={defaultAvatar} />
                <div className="hive_support_client_tickets_item_body_details">
                {ticket.customer_seen_status == 'new_reply' ? <span className={ `ticket-watch-status ${ticket.customer_seen_status}` }>{__('New Reply Added', 'hive-support')}</span> : ''}
                  <a onClick={() => handleSelectId(ticket.id)}>
                    {ticket.title}
                    <span>#{ticket.id}</span>
                  </a>

                  <p>{ticket.content}</p>
                </div>
              </div>
              <div className="hive_support_client_tickets_item_footer">
                <ul>
                  <li>
                    <span>{__( "Last Update:", "hive-support" )}</span>{" "}
                    <strong> {moment.tz(ticket.updated_at, hive_front.time_zone).fromNow()}</strong>
                  </li>
                  <li>
                    <span> {__( "Status:", "hive-support" )} </span>{" "}
                    <strong> {ticket.ticket_status} </strong>
                  </li>
                  <li>
                    <span> {__( "Ticket Created:", "hive-support" )} </span>{" "}
                    <strong> {ticket.created_at.split(" ")[0]} </strong>
                  </li>
                </ul>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          className="hive_support_client_tickets_empty"
          style={{ display: "flex" }}
        >
          {__( "You have no previously created tickets.", "hive-support" )}
        </div>
      )}
    </div>
  );
};

export default Tickets;
